import moment from "moment";
import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  const pathname = window.location.pathname;
  return (
    <>
      <div className="m-auto my-20 text-center">
        <p>Copyright © {moment().year()} EXPLODE MEDIA FZ LLC</p>
        {pathname == "/" && (
          <p className="px-10">
            FDAU0194, Compass Building, Al Shohada Road, AL Hamra Industrial
            Free Zone, RAK, UAE 10055
          </p>
        )}
      </div>
      <footer className="py-7 px-4 bg-blackbg">
        <div className="container m-auto">
          <div className="flex flex-col md:flex-row justify-between gap-4 md:gap-5 items-center">
            <p className="text-sm sm:text-base font-semibold text-white">
              Email :- support@fastmate.app
            </p>
            <ul className="flex gap-2 flex-col items-center sm:flex-row sm:gap-5 lg:gap-14">
              {[
                { pagename: "Terms", pageurl: "/policy/terms" },
                {
                  pagename: "Privacy Policy",
                  pageurl: "/policy/privacy-policy",
                },
                {
                  pagename: "Trusted Sources",
                  pageurl: "/policy/trusted-sources",
                },
                { pagename: "Contact Us", pageurl: "/policy/contact" },
              ]?.map((policy_row, index) => {
                return (
                  <li key={index}>
                    <Link
                      to={policy_row?.pageurl}
                      className="text-sm sm:text-base font-semibold text-white"
                    >
                      {policy_row?.pagename}
                    </Link>
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
      </footer>
    </>
  );
};
export default React.memo(Footer);
